/**
 * 用于多厅主的不同配置，除了Constant.ts，其他文件不要使用这个文件
 */

let PackageConfig = {
    updatePackageName:"com.kingkong.a1038ykjhgf0217",
    WebsiteSign:"prod/heng/B29_1038",
    PackageName: "1038棋牌",
    // 平台标示符
    PackageFlag: "newPK",
    // 服务器地址
    ServerAddresses: [
        'https://xinpujing.go377.com',
        'https://xinpujing1.go376.com',
        'https://xinpujing.go376.com',
    ],

    closeYxd:true,
    // 游戏盾相关
    // 游戏盾相关需要修改
    // GameShieldAccessKey: "nouse",
    // GameShieldGroupName: "nouse.5RP86x1tR6.ftnormal01aj.com",
    // GameShieldDomain: "nouse",
    // GameShieldPort: "80",
    InstallSDK: 2,
}

export default PackageConfig
